"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AspectRatio = void 0;

var _theming = require("@storybook/theming");

var getRatioNumber = function getRatioNumber(ratio) {
  var parts = ratio.split('/');
  return parseInt(parts[0], 10) / parseInt(parts[1], 10);
};

var AspectRatio = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eiii4gi0"
} : {
  target: "eiii4gi0",
  label: "AspectRatio"
})("overflow:hidden;@supports (aspect-ratio: 1){aspect-ratio:", function (props) {
  return props.ratio;
}, ";&>*{max-width:100%;}}@support not (aspect-ratio: 1){position:relative;width:100%;height:0;padding-bottom:", function (props) {
  return getRatioNumber(props.ratio) * 100;
}, "%;&>*{position:absolute;width:100%;height:auto;left:0;top:0;}}");
exports.AspectRatio = AspectRatio;